<template>
    <div class="container mt-3">
            <div class="row">
                <categories 
                    :tasks="tasks" 
                    v-for="(status, id) in category" 
                    :key="status" 
                    :status="status" 
                    @showModalCreate="showModalCreate(status)" 
                    @showModalEdit="showModalEdit"
                    @show-modal-delete="showModalDelete"
                    @showModalError="showModalError"
                    @on-drop="onDrop"
                    @start-drag="startDrag"
                ></categories>
            </div>
            <modal 
                :modalMaterial="modalMaterial"
                @create-new-todo="createNewTodo" 
                @edit-todo="editTodo" 
                @delete-task="deleteTask"
                >
            </modal>
            <a href="#" class="card-link"  data-bs-toggle="modal" data-bs-target="#exampleModal" style="display:none" ref="buttonOpen"></a>
        </div>
</template>


<script>
import categories from './categories.vue';
import modal from './modal.vue';
export default {
    name: "boards",
    components: { categories, modal},
    props:["tasks","status"],
    data() {
        return {
            message: 'Hello world',
            category: ['backlog','todo','doing','completed'],
            modalMaterial : {
                id: '',
                category: '',
                title: '',
                action: ''
            },
            modalShow: false
        };
    },
    methods: {
        showModalCreate(status){
            this.modalShow = true
            this.modalMaterial.category = status
            this.modalMaterial.action = 'create'
        },
        showModalEdit(data){
            this.modalShow = true
            this.modalMaterial.id = data.id,
            this.modalMaterial.action = 'update',
            this.modalMaterial.category = data.category,
            this.modalMaterial.title = data.title
        },
        showModalError(){
            // this.$bvModal.show('modals')
            this.$refs.buttonOpen.click()
            this.modalMaterial.action = 'error'
        },
        showModalDelete(id){
            // console.log(id)
            this.modalShow = true,
            this.modalMaterial.id = id,
            this.modalMaterial.action = 'delete'
        },
        createNewTodo(data) {
            this.$emit('create-new-todo',data)
        },
        editTodo(data){
            this.$emit('edit-todo',data)
        },
        deleteTask(id){
            this.$emit('delete-task',id)
        },
        startDrag(ev, item) {
            this.$emit('start-drag',ev, item)
        },
        onDrop(ev, category) {
            this.$emit('on-drop',ev,category)
        }
    }
};
</script>

<style scoped>
</style>